import { Component, Input, TemplateRef, ViewChild } from "@angular/core";
import { HtmlTipComponent } from "./../html-tip/html-tip.component";

@Component({
    selector: "kno2-custom-modal-header",
    templateUrl: "./custom-modal-header.component.html",
    styleUrls: ["./custom-modal-header.component.scss"],
    standalone: false
})
export class CustomModalHeaderComponent {
    @ViewChild("titleRef") public titleTemplate: TemplateRef<any>;
    @Input() public title: string;
    @Input() public tooltip?: string;

    public htmlTip = HtmlTipComponent;
}
